import { guttersApp } from '../../../utils/stylesUtils';

export default (theme) => ({
  root: {
    ...guttersApp(theme.spacing, theme.breakpoints),
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
});
